"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rightsholderMaintenanceSchema = exports.rightsholderMaintenanceFormFields = void 0;
const zod_1 = require("zod");
const error_messages_1 = require("@Const/error-messages");
const error_messages_2 = require("@Entities/schemas/work/error-messages");
const validate_1 = require("@App/helpers/validate");
const form_field_types_1 = require("@App/enum/form-field-types");
const populate_schema_1 = __importDefault(require("@App/forms/v2/helpers/populate-schema"));
const address_schema_1 = require("@Entities/schemas/common/address-schema");
const phone_number_schema_1 = require("@Entities/schemas/common/phone-number-schema");
const emailKey = 'email';
const nameKey = 'name';
const ipiNumberKey = 'ipiNumber';
const hfaPublisherNumberKey = 'hfaPublisherNumber';
const isniKey = 'isni';
const ipIdKey = 'ipId';
const emailLabel = 'Email Address';
const nameLabel = 'Name';
const ipiNumberLabel = 'Publisher IPI Number';
const hfaPublisherNumberLabel = 'Publisher Account Number';
const isniLabel = 'ISNI';
const rightsholderMaintenanceBaseSchema = zod_1.z.object({
    [emailKey]: zod_1.z
        .string({
        invalid_type_error: error_messages_1.REQUIRED_MESSAGE,
    })
        .min(1, error_messages_1.REQUIRED_MESSAGE)
        .trim()
        .toLowerCase()
        .email(error_messages_1.EMAIL_MESSAGE)
        .max(2000, (0, error_messages_2.stringSizeMaxMessage)(emailLabel, 2000))
        .refine(validate_1.isNotAnReservedEmailBoolean, error_messages_1.NO_RESERVED_EMAIL_MESSAGE),
    [nameKey]: zod_1.z
        .string({
        required_error: error_messages_1.REQUIRED_MESSAGE,
    })
        .min(1, error_messages_1.REQUIRED_MESSAGE)
        .max(200, (0, error_messages_2.stringSizeMaxMessage)(nameLabel, 200)),
    [address_schema_1.extendedAddressFormKey]: address_schema_1.extendedAddressSchema,
    [phone_number_schema_1.phoneNumberFormKey]: phone_number_schema_1.phoneNumberSchema,
    [ipiNumberKey]: zod_1.z
        .string()
        .max(11, (0, error_messages_2.stringSizeMaxMessage)(ipiNumberLabel, 11))
        .refine((ipi) => (0, validate_1.IPIValidator)(ipi, false), 'Invalid IPI Number')
        .optional()
        .nullish(),
    [hfaPublisherNumberKey]: zod_1.z.string().max(6, (0, error_messages_2.stringSizeMaxMessage)(hfaPublisherNumberLabel, 6)).optional().nullish(),
    [isniKey]: zod_1.z
        .string()
        .refine((isni) => (0, validate_1.IsniValidator)(isni, false), 'Invalid ISNI')
        .optional()
        .nullish(),
});
const rightsholderMaintenanceSchema = rightsholderMaintenanceBaseSchema.merge(zod_1.z.object({
    [ipIdKey]: zod_1.z.number(),
}));
exports.rightsholderMaintenanceSchema = rightsholderMaintenanceSchema;
const rightsholderMaintenanceFormFieldsNoSchema = {
    [nameKey]: {
        name: nameKey,
        label: nameLabel,
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
    [emailKey]: {
        name: emailKey,
        label: emailLabel,
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
    [address_schema_1.extendedAddressFormKey]: address_schema_1.extendedAddressFormFields,
    [phone_number_schema_1.phoneNumberFormKey]: phone_number_schema_1.phoneNumberFormFields,
    [ipiNumberKey]: {
        name: ipiNumberKey,
        label: ipiNumberLabel,
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
    [hfaPublisherNumberKey]: {
        name: hfaPublisherNumberKey,
        label: hfaPublisherNumberLabel,
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
    [isniKey]: {
        name: isniKey,
        label: isniLabel,
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
};
const rightsholderMaintenanceFormFields = (0, populate_schema_1.default)(rightsholderMaintenanceFormFieldsNoSchema, rightsholderMaintenanceSchema);
exports.rightsholderMaintenanceFormFields = rightsholderMaintenanceFormFields;
